import { Component, OnInit } from '@angular/core';
import { IndicatorsChartService, IndicatorsService } from '../../../../services/indicators/indicators.service';
import { AnalyticsService } from '../../../../services/analytics/analytics.service';
import { CustomerCampaignService } from '../../../../services/customer/customer-campaign.service';
import { LoyaltyChart } from '../../../../models/loyalty-chart-config.model';
import { TranslateService} from '@ngx-translate/core/';
import { QFilterModel } from '../../../../models/qfilter.model';
import { IndicatorBoxModel } from '../../../../models/indicator-box.model';
import { IndicatorsSearchToolbarModel } from '../../../../models/indicators-search-toolbar-model.model';

@Component({
  selector: 'app-overview-loyalty-points',
  templateUrl: './overview-loyalty-points.component.html',
  styleUrls: ['./overview-loyalty-points.component.css']
})
export class OverviewLoyaltyPointsComponent implements OnInit {

  public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();
  public indicators: IndicatorBoxModel[] = [];

  translations: any;

  trendPuntiChart: LoyaltyChart;
  accantonamentoChart: LoyaltyChart;

  public data: QFilterModel;

  constructor (
    private indicatorService: IndicatorsService,
    private chartsService: IndicatorsChartService,
    private svcAnalytics: AnalyticsService,
    private srvCustomerCampaign: CustomerCampaignService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.translate.get([
      'loyalty_chart.trendPunti',
      'loyalty_chart.accantonamento',
      'loyalty_chart.period'
    ]).subscribe((t) => {
      this.translations = {
        trendPunti: t['loyalty_chart.trendPunti'],
        accantonamento: t['loyalty_chart.accantonamento'],
        etichetta_periodo: t['loyalty_chart.period']
      };

      this.initCharts();
    });
  }

  initCharts() {
    this.trendPuntiChart = new LoyaltyChart('column', '€');
    this.trendPuntiChart.options.xAxis.title.text = this.translations.etichetta_periodo;
    this.accantonamentoChart = new LoyaltyChart('line', '€');
    this.accantonamentoChart.options.xAxis.title.text = this.translations.etichetta_periodo;
  }

  setChartInstance(chart: LoyaltyChart, chartInstance) {
    chart.instance = chartInstance;
  }

  public searchValueTrend(data: QFilterModel) {
    this.data = data;

    this.translate.get([
      'indicator.valore_punti_erogati',
      'indicator.valore_punti_redenti',
      'indicator.perc_redenzione',
      'indicator.fondo_accantonamento',
    ]).subscribe(t => {
      this.indicators = [];

      this.indicatorService.indicatorCalculation('Q029', this.data).switchMap((res) => {
        const erogati = [
          res.find(ind => ind.name === 'valore_punti_erogati')
        ];

        const redenti = [
          res.find(ind => ind.name === 'valore_punti_redenti')
        ];

        const redenzione = [
          res.find(ind => ind.name === 'perc_redenzione')
        ];

        this.indicators.push(new IndicatorBoxModel(erogati, {dynamic: true, unit_period_prec: '€'}, t));
        this.indicators.push(new IndicatorBoxModel(redenti, {dynamic: true, unit_period_prec: '€'}, t));
        this.indicators.push(new IndicatorBoxModel(redenzione, {dynamic: true, unit_period_prec: '%'}, t));

        return this.indicatorService.indicatorCalculation('Q032', this.data);
      }).subscribe((res) => {
        this.indicators.push(new IndicatorBoxModel(res, {dynamic: true, unit_period_prec: '€'}, t));
      });

    });

    this.indicatorService.getChart('Q035', this.data).subscribe(resp => {

      const res = resp.series;

      this.chartsService.loadChartBase(this.trendPuntiChart, res[0], [res[1], res[2]], this.translate, LoyaltyChart.colors, 'loyalty_chart');
      this.chartsService.loadChartBase(this.accantonamentoChart, res[0], [res[3]], this.translate, LoyaltyChart.colors, 'loyalty_chart');

    });
  }

  public resetData() {
    this.indicators = [];
    this.data = null;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/overview/overview-loyalty/overview-loyalty-points/overview-loyalty-points.component.ts